import React from 'react';
import { Zap, CheckCircle2, Shield } from 'lucide-react';
import { Card, CardContent } from './ui/card';

const ElectricalPartner = () => {
  return (
    <section className="py-16 bg-slate-900">
      <div className="container mx-auto px-4">
        <div className="max-w-6xl mx-auto">
          <div className="grid md:grid-cols-2 gap-8 items-center">
            {/* Left Column - Info */}
            <div>
              <div className="flex items-center gap-3 mb-4">
                <div className="w-12 h-12 bg-amber-500 rounded-lg flex items-center justify-center">
                  <Zap className="text-white" size={28} />
                </div>
                <h2 className="text-3xl md:text-4xl font-bold text-white">
                  Electrical Services
                </h2>
              </div>
              <p className="text-slate-300 text-lg mb-6">
                All electrical work carried out by <span className="text-amber-400 font-semibold">Richard Kent</span>, a fully qualified and certified electrician.
              </p>
              <div className="space-y-4">
                <div className="flex items-start gap-3">
                  <Shield className="text-amber-500 flex-shrink-0 mt-1" size={24} />
                  <div>
                    <h3 className="text-white font-semibold mb-1">NICEIC Approved Contractor</h3>
                    <p className="text-slate-400 text-sm">Certified by the UK's leading electrical certification body</p>
                  </div>
                </div>
                <div className="flex items-start gap-3">
                  <CheckCircle2 className="text-amber-500 flex-shrink-0 mt-1" size={24} />
                  <div>
                    <h3 className="text-white font-semibold mb-1">Fully Insured & Qualified</h3>
                    <p className="text-slate-400 text-sm">Complete peace of mind for all electrical installations</p>
                  </div>
                </div>
                <div className="flex items-start gap-3">
                  <CheckCircle2 className="text-amber-500 flex-shrink-0 mt-1" size={24} />
                  <div>
                    <h3 className="text-white font-semibold mb-1">Part P Compliant</h3>
                    <p className="text-slate-400 text-sm">All work meets Building Regulations standards</p>
                  </div>
                </div>
              </div>
            </div>

            {/* Right Column - Badge/Certification */}
            <div className="flex justify-center">
              <Card className="bg-white border-4 border-amber-500 p-8 text-center max-w-sm">
                <CardContent className="pt-6">
                  <div className="w-20 h-20 bg-amber-100 rounded-full flex items-center justify-center mx-auto mb-4">
                    <Zap className="text-amber-600" size={40} />
                  </div>
                  <h3 className="text-2xl font-bold text-slate-900 mb-2">Richard Kent</h3>
                  <div className="inline-block bg-amber-500 text-white px-4 py-2 rounded-full font-semibold mb-4">
                    NICEIC Approved
                  </div>
                  <p className="text-slate-700 mb-4">
                    Qualified Electrician
                  </p>
                  <div className="border-t border-slate-200 pt-4">
                    <p className="text-sm text-slate-600">
                      All electrical installations certified and compliant with UK Building Regulations
                    </p>
                  </div>
                </CardContent>
              </Card>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
};

export default ElectricalPartner;
